import { useQuery } from "@tanstack/react-query";
import api from "../services/api";

export function useFilterStates(options = {}) {
  return useQuery({
    queryKey: ["filterStates"],
    queryFn: async () => {
      const response = await api.get("/get-filter-states");
      const data = response?.data?.dataset?.data?.states_list || response?.data?.dataset?.data || response?.data?.dataset?.states || response?.data?.dataset || response?.data || [];
      const statesArray = Array.isArray(data) ? data : [];
      return statesArray.map(state => ({
        ...state,
        id: state.id || state.state_id,
        name: state.name || state.state_name || state.title
      }));
    },
    ...options,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
